import { render, staticRenderFns } from "./ContactMain.vue?vue&type=template&id=2f481f19&scoped=true&"
import script from "./ContactMain.vue?vue&type=script&lang=js&"
export * from "./ContactMain.vue?vue&type=script&lang=js&"
import style0 from "./ContactMain.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ContactMain.vue?vue&type=style&index=1&id=2f481f19&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f481f19",
  null
  
)

export default component.exports